import { defaultPostHeaderForJsonData } from '@inwink/apibase';
import { getCustomerEntityDataSource, getCustomerAPIProxy } from './index';

export function customerDataSource(customerId: string) {
    return getCustomerEntityDataSource<AuthTenant.ICustomer>(customerId, "customer", "Customer");
}

export function getMyCustomers(): Promise<AuthTenant.ICustomer[]> {
    const proxy = getCustomerAPIProxy();
    return proxy.getJson("customers");
}

export function saveConfiguration(customerId: string, fragment: string, configuration): Promise<AuthTenant.ICustomer> {
    const proxy = getCustomerAPIProxy();
    return proxy.postJson(`${customerId}/configuration/save/${fragment}`,
        JSON.stringify(configuration), defaultPostHeaderForJsonData);
}

export function getConfiguration(customerId: string): Promise<any> {
    const proxy = getCustomerAPIProxy();
    return proxy.getJson(customerId + "/configuration");
}
